import { useRoute } from 'vue-router';

export function usePersistentFilters<T extends object>(filters: T, keysToPersist: (keyof T)[], storageKeyPrefix = 'app-filters') {
    const route = useRoute();

    const storageKey = computed(() => `${storageKeyPrefix}:${String(route.name)}`);

    const saved = localStorage.getItem(storageKey.value);
    if (saved) {
        try {
            const parsed = JSON.parse(saved);
            for (const key of keysToPersist) {
                if (key in parsed) {
                    filters[key] = parsed[key];
                }
            }
        } catch (e) {
            console.warn('Failed to parse stored filters', e);
        }
    }

    const refs = toRefs(filters);
    for (const key of keysToPersist) {
        watch(
            refs[key],
            () => {
                const dataToSave: Partial<T> = {};
                for (const k of keysToPersist) {
                    dataToSave[k] = filters[k];
                }
                localStorage.setItem(storageKey.value, JSON.stringify(dataToSave));
            },
            { deep: false }
        );
    }
}
